import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import deletion from 'services/deletion';
// Externals
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Material helpers
import { withStyles, Button } from '@material-ui/core';

// Material components
import { Typography } from '@material-ui/core';

// Shared components
import { Paper } from 'components';

// Component styles
import styles from './styles';
import citations from 'services/citations';
import { stubTrue } from 'lodash';

class BookCard extends Component {
  render() {
    const { classes, className, book, citations } = this.props;

    const rootClassName = classNames(classes.root, className);

   // let citationsCount = headword.relationships.citations.count;
    let numCitations1 = citations.find(c => c.bookId === book.id);
    let numCitations = numCitations1 ? numCitations1.count : 0
    return (
      
        <Paper className={rootClassName}>
          <Link to={`/book/${book.id}`}>
          <div className={classes.details}>
            <Typography
              className={classes.title}
              variant="h4"
            >
              {this.title()}
            </Typography>
            <Typography
              className={classes.description}
              variant="body1"
            >
              {this.search()}
              {numCitations + " Quotations"}
            </Typography>
          </div>
          </Link>
          {(!this.props.merge) && (
          <Button style={{marginTop:'13px'}} onClick={event => this.delete()} color="primary" size="small" variant="outlined">Delete</Button>
          )}
        </Paper>

    );
  }

  delete(){
    const { classes, className, book, citations } = this.props;

    if(window.confirm("Are you sure you want to permanantly delete this entry?")){
        let test = deletion.deleteBook(book);
        test.then(( value ) => 
        { 
          window.alert("Entry Deleted");
          window.location.reload();
        }
        ).catch ((error) => 
        {
          window.alert("Please delete all quotations for this book first");
        });
    }
  }

  /*quotes(){
    let visibleHeadwords = Object.values(this.props.citations.attributes).filter(citation => citation.bookId==this.props.book.id);
    return (visibleHeadwords.length + " Quotations");
  } */

  filter(text){
    const {searchString} = this.props;
    var title="";
    let match = true;
    if(searchString.length==1){
      title = "";
      for (var i = 0; i<text.length; i++){
        if(searchString.toLowerCase().includes(text.charAt(i).toLowerCase())){
          title = title + "<mark>"+text.charAt(i)+"</mark>";
        } else {
          title = title + text.charAt(i);
        }
      }
    } else if(searchString.length>1){
      title = "";
      for (var i = 0; i<text.length; i++){
        if(searchString.charAt(0).toLowerCase()==(text.charAt(i).toLowerCase())){
          for(var j = 1; j<searchString.length; j++){
            if(i+j<text.length && searchString.charAt(j).toLowerCase()==(text.charAt(i+j).toLowerCase())){
              match = true;
            } else {
              match = false;
              title = title + text.substring(i, i+j+1);
              i = i+j;
              break;
            }
          }
          if(match){
            title = title + "<mark>"+text.substring(i, i+j)+"</mark>" + text.charAt(i+j);
            i = i+j;
          }
        } else {
          title = title + text.charAt(i);
        }
      }
    } else {
      title = text;
    }
      return(title);
  }

  title(){
    const {authorCheck, editorCheck, yearCheck, typeCheck, notesCheck, legacyNotesCheck} = this.props;
    if(!authorCheck && !editorCheck && !yearCheck && !typeCheck && !notesCheck && !legacyNotesCheck){
      if(this.props.book.title!=undefined){
        let title = this.filter(this.props.book.title);
        return(
          <div>
          <div dangerouslySetInnerHTML={{__html:title}}></div>
          </div>
        );
      } else {
        return(this.props.book.title);
      }
    } else {
      return(this.props.book.title);
    }
  }

  search(){
    const {searchString, authorCheck, editorCheck, yearCheck, typeCheck, 
    notesCheck, legacyNotesCheck, otherCheck} = this.props;
    if(authorCheck){
      if(this.props.book.author!=undefined){
        let author = this.filter(this.props.book.author);
        author = "Author: " + author;
        return(
          <div>
          <div dangerouslySetInnerHTML={{__html:author}}></div>
          </div>
        );
      } 
    } else if(editorCheck){
      if(this.props.book.editor!=undefined){
        let editor = this.filter(this.props.book.editor);
        editor = "Editor: " + editor;
        return(
          <div>
          <div dangerouslySetInnerHTML={{__html:editor}}></div>
          </div>
        );
      }
    } else if(yearCheck){
      if(this.props.book.yearPublished!=undefined){
        let yearPublished = this.filter(this.props.book.yearPublished);
        yearPublished = "Year Published: " + yearPublished;
        return(
          <div>
          <div dangerouslySetInnerHTML={{__html:yearPublished}}></div>
          </div>
        );
      }
    } else if(typeCheck){
      if(this.props.book.type!=undefined){
        let type = this.filter(this.props.book.type);
        type = "Type: " + type;
        return(
          <div>
          <div dangerouslySetInnerHTML={{__html:type}}></div>
          </div>
        );
      }
    } else if(notesCheck){
      if(this.props.book.notes!=undefined){
        let notes = this.filter(this.props.book.notes);
        notes = "Notes: " + notes;
        return(
          <div>
          <div dangerouslySetInnerHTML={{__html:notes}}></div>
          </div>
        );
      }
    } else if(legacyNotesCheck){
      if(this.props.book.legacyNotes!=undefined){
        let legacyNotes = this.filter(this.props.book.legacyNotes);
        legacyNotes = "Legacy Notes: " + legacyNotes;
        return(
          <div>
          <div dangerouslySetInnerHTML={{__html:legacyNotes}}></div>
          </div>
        );
      }
    } else if(otherCheck){
      if(this.props.book.legacyNotes!=undefined && this.props.book.legacyNotes!=""){
        let other = "Legacy Notes: " + this.props.book.legacyNotes;
        return(
          <div>
          <div dangerouslySetInnerHTML={{__html:other}}></div>
          </div>
        );
      }
    }
  }
}

BookCard.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  book: PropTypes.object.isRequired
};

export default withStyles(styles)(BookCard);
